import { CAMERA_GIMBALS, paidCameraGimbal, type CameraGimbalId } from '../../../renderer/src/camera-gimbal';
import type { CameraDistanceId, CameraPlatformId } from '../../../renderer/src/presets';
import { resolveCameraDistance } from '../domain/camera-distance';
import { cameraGimbalDisplay } from './camera-gimbal-display';

export function CameraGimbalControl({ value, distance, style, onChange, transition, keyframing = false }: {
  value: CameraGimbalId; distance: CameraDistanceId; style: CameraPlatformId;
  onChange: (mode: CameraGimbalId) => void; transition?: string | undefined; keyframing?: boolean;
}) {
  const { active, selectable, value: displayed } = cameraGimbalDisplay(value, distance, style, keyframing);
  const selected = CAMERA_GIMBALS.find(item => item.id === value)!;
  const adjustableFraming = `${resolveCameraDistance('close').label}, ${resolveCameraDistance('x-close').label}, ${resolveCameraDistance('xx-close').label}, and ${resolveCameraDistance('telephoto-800').label}`;
  return <>
    <label className="studio-select-row">Camera Gimbal<select aria-describedby="studio-gimbal-help"
      value={transition ? 'transition' : displayed} disabled={!selectable}
      onChange={event => onChange(event.target.value as CameraGimbalId)}>
      {transition && <option value="transition">{transition}</option>}
      {CAMERA_GIMBALS.map(item => <option key={item.id} value={item.id}>{item.label}{selectable && paidCameraGimbal(item.id, distance, style) ? ' · PRO' : ''}{!selectable && displayed === item.id ? ' · Automatic' : ''}</option>)}
    </select></label>
    <p id="studio-gimbal-help">{active ? `${selected.description}${paidCameraGimbal(value, distance, style) ? ' Preview included; paid access required to export.' : ''}`
      : style === 'uav' ? `Gimbal is inactive for UAV. ${selected.label} is remembered for closer views.`
        : `${selected.label} is remembered for ${adjustableFraming}.`}</p>
  </>;
}
